export default {
    DefaultLocale: 'bg',
    GoogleAnalyticsID: 'UA-59241087-3',
    GoogleAPIkey: 'AIzaSyAcapzqeFF7hkveR9kQ934mMI8tX3iwSlc',
    spreadsheetId: '1ZtH2oRyCYot6vM0eqIctg2c24khybCmdK-672TNCWuU',
    Pages: {
        '/': {
            view: 'HomePage',
            title: 'Начало',
            exact: true
        },
        '/the-project': {
            view: 'TheProject',
            title: 'Проектът',
            exact: true
        },
        '/travels': {
            view: 'Travels',
            title: 'Пътешествията',
            exact: true
        },
        '/ekip': {
            view: 'Team',
            title: 'Създателите',
            exact: true
        },
        '/publications': {
            view: 'Publications',
            title: 'Публикации',
            exact: true
        },
        '/conferences': {
            view: 'Conferences',
            title: 'Научни форуми',
            exact: true
        },
        '/copyright': {
            view: 'Copyright',
            title: 'Авторско право',
            exact: true
        },
        '/kompilativna-redakcia': {
            view: 'KompilativnaRedakcia',
            title: 'Компилативна редакция',
            exact: true   
        },
        '/rilska-prepravka': {
            view: 'RilskaPrepravka',
            title: 'Рилска преправка',
            exact: true
        },
        '/pop-yoanova-prepravka': {
            view: 'PopYoanovaPrepravka',
            title: 'Поп-Йоанова преправка',
            exact: true
        },
        '/grigorovicheva-prepravka': {
            view: 'GrigorovichevaPrepravka',
            title: 'Григоровичева преправка',
            exact: true
        },
        '/hilendarska-prepravka-1': {
            view: 'HilendarskaPrepravka1',
            title: 'Първа Хилендарска преправка',
            exact: true
        },
        '/starozagorska-prepravka-1': {
            view: 'StarozagorskaPrepravka1',
            title: 'Първа Старозагорска преправка',
            exact: true
        },
        '/haritonova-prepravka-1': {
            view: 'HaritonovaPrepravka1',
            title: 'Първа Харитонова преправка',
            exact: true
        },
        '/haritonova-prepravka-2': {
            view: 'HaritonovaPrepravka2',
            title: 'Втора Харитонова преправка',
            exact: true
        },
        '/haritonova-prepravka-3': {
            view: 'HaritonovaPrepravka3',
            title: 'Трета Харитонова преправка',
            exact: true
        },
        '/gerov-prepis': {
            view: 'GerovPrepis',
            title: 'Геров препис',
            exact: true
        },
        '/kesariev-prepis': {
            view: 'KesarievPrepis',
            title: 'Кесариев препис',
            exact: true
        },
        '/lamanski-prepis': {
            view: 'LamanskiPrepis',
            title: 'Ламански препис',
            exact: true
        },
        '/panagyurski-prepis': {
            view: 'PanagyurskiPrepis',
            title: 'Панагюрски препис',
            exact: true
        },
        '/gavril-krustevich-manuscripts': {
            view: 'GavrilKrustevich',
            title: 'Ръкописи с очевидец Гаврил Кръстевич',
            exact: true
        },
        '/bibliography': {
            view: 'Bibliography',
            title: 'Библиография',
            exact: true
        },
        '/horata-razkazi': {
            view: 'Preduvedumlenie',
            title: 'Предуведомление',
            exact: true
        },
        '/horata-razkazi/zavrazkata': {
            view: 'Zavrazkata',
            title: 'Завръзката',
            exact: true
        },
        '/horata-razkazi/kuluminacii': {
            view: 'Kuluminacii',
            title: 'Кулуминации и развръзки',
            exact: true
        },
        '/horata-razkazi/ne-znainite': {
            view: 'NeZnainite',
            title: '(Не)знайните хора разкази',
            exact: true
        },
        '/horata-razkazi/posleslov': {
            view: 'Posleslov',
            title: 'Послеслов',
            exact: true
        },
        '/fondation': {
            view: 'Fondation',
            title: 'Фондацията',
            exact: true
        }
    }
}


// WEBPACK FOOTER //
// ./src/config.js